/* Built In Imports */

/* External Imports */
import { Link } from '@chakra-ui/next-js';
import { Box } from '@chakra-ui/react';

import { GoArrowLeft } from 'react-icons/go';
import { IoIosArrowBack } from 'react-icons/io';
/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
// import EmbedIcons from '@app-ps/components/EmbedIcons';

import MediaEmbed from '@app-ps/Components/Embeds/MediaEmbed';
import EmbedIcons from '@app-ps/Components/Icon/EmbedIcons';

import BannerAudioEmbed from '@app-ps/Components/Embeds/BannerAudioEmbed';
// import { getEmbedUrl } from '../Utility/utils';
import { getEmbedUrl } from '@app-ps/Components/Utility/utils';

/* Services */
/* Styles */

/**
 * Renders the Banner component
 *
 * @param {object} sectionContent - Data for section
 * @returns {ReactElement} Banner component
 */

const ArticleBanner = ({ pageData, type }) => {
  return (
    <Box
      w="100%"
      pos="relative"
      paddingTop={{ base: '2rem', lg: '8rem' }}
      bgImage="linear-gradient(170.9deg, #01060A 18.08%, #0B345E 95.07%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))"
      bgSize="100% calc(100% - 70px)"
      minH={{ '2xl': 'auto', lg: '50vh', base: 'auto' }}
    >
      <Box
        pos="absolute"
        display={{ base: 'none' }}
        right={{ xl: '6%', '2xl': '18%' }}
        top={{ xl: '5%', '2xl': '5%' }}
      >
        <EmbedIcons flexDirection="column" iconColor="#F1EDE9" />
      </Box>

      <Box marginX={{ lg: 'auto', base: '0rem' }} maxWidth={{ lg: '970px' }}>
        <Box
          mx={{ base: '1rem', md: 'auto' }}
          fontSize={{ lg: '60px', base: '28px' }}
          fontWeight={700}
          gap={{
            '2xl': '4rem',
            xl: '2rem',
            lg: '4rem',
            md: '2rem',
            base: '1rem',
          }}
          alignItems={{ base: 'start' }}
          display={'flex'}
          letterSpacing={'0.16px'}
          lineHeight={{ base: '33.6px', lg: '72px' }}
          fontFamily="var(--FedraSerifDisplay-Bold)"
          color={'#FEFAF6'}
        >
          <Link
            href="/project-samskriti/blog"
            prefetch
            _hover={{ boxShadow: 'none' }}
            _focus={{ boxShadow: 'none' }}
          >
            <Box fontSize={{ lg: '2.5rem' }} mt={{ lg: '1rem' }}>
              <Box
                display={{ base: 'block', lg: 'none', '2xl': 'block' }}
                fontSize={{ base: '2rem', '2xl': '44px' }}
              >
                <GoArrowLeft />
              </Box>
              <Box
                display={{ base: 'none', lg: 'block', '2xl': 'none' }}
                mt="-.5rem"
              >
                <IoIosArrowBack fontSize="3rem" />
              </Box>
            </Box>
          </Link>
          <Box
            fontSize={{ base: '28px', lg: '50px', '2xl': '60px' }}
            lineHeight={{ base: '33.6px', md: '60px', '2xl': '72px' }}
            letterSpacing={'1%'}
          >
            {pageData?.title}
            {pageData?.summary && (
              <Box
                fontWeight={400}
                color={'#FFFFFF'}
                textAlign={{ base: 'left', lg: 'left' }}
                fontSize={{ base: '1rem', md: '1.125rem' }}
                fontFamily="var(--FedraSansStd-book)"
                lineHeight={{ base: '1.6rem', md: '1.8rem' }}
                letterSpacing={'0.32px'}
                my="1rem"
              >
                {pageData.summary}
              </Box>
            )}
          </Box>
        </Box>
        <Box pos="relative" mt={{ base: '1.5rem', md: '1.5rem', lg: '4rem' }}>
          {!pageData?.video?.url && (
            <LazyLoadImageComponent
              alt={pageData?.heroImage?.alt}
              width="100%"
              src={pageData?.heroImage?.url}
              // maxH="543px"
            />
          )}
          {pageData?.audioUrl && !pageData?.video?.url && (
            <BannerAudioEmbed
              sectionContent={{
                embedUrl: pageData?.audioUrl,
              }}
            />
          )}
        </Box>
        {pageData?.video?.url && (
          <Box width="100%" mt={{ lg: '2rem' }} top="0" height="100%">
            <MediaEmbed
              maxW="970px"
              width="100%"
              height={{ base: '200px', md: '315px', lg: '545px' }}
              backgroundPosition="center"
              sectionContent={{
                embedUrl: pageData?.video?.url,
              }}
              embedUrl={getEmbedUrl(pageData?.video.url)}
              cookie
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ArticleBanner;
